<div class="gridheight mat-elevation-z8 viewport" style="margin-top: 13px;">
    <table mat-table [dataSource]="dataSource" class="viewport"  matSort>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
                <div>
                    <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openEditForm(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>
        <!-- ID Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <!-- Customer Name Column -->
        <ng-container matColumnDef="tankName">
            <th mat-header-cell *matHeaderCellDef> Tank </th>
            <td mat-cell *matCellDef="let element"> {{element.tankName}} </td>
        </ng-container>

        <!-- datecaptured Column -->
        <ng-container matColumnDef="datecaptured">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element"> {{element.datecaptured | date:'MM/dd/yyyy hh:mm a'}} </td>
        </ng-container>

        <!-- Height Column -->
        <ng-container matColumnDef="height">
            <th mat-header-cell *matHeaderCellDef> Height </th>
            <td mat-cell *matCellDef="let element"> {{element.height}} </td>
        </ng-container>

        <!-- Notes Column -->
        <ng-container matColumnDef="volume">
            <th mat-header-cell *matHeaderCellDef> Volume </th>
            <td mat-cell *matCellDef="let element"> {{element.volume}} </td>
        </ng-container>

        <!-- Loads Column -->
        <ng-container matColumnDef="loads">
            <th mat-header-cell *matHeaderCellDef> Loads </th>
            <td mat-cell *matCellDef="let element"> {{element.loads}} </td>
        </ng-container>

        <!-- Other Column -->
        <ng-container matColumnDef="other">
            <th mat-header-cell *matHeaderCellDef> Other </th>
            <td mat-cell *matCellDef="let element"> {{element.other}} </td>
        </ng-container>

        <ng-container matColumnDef="percent_SAD">
            <th mat-header-cell *matHeaderCellDef> % S-AD </th>
            <td mat-cell *matCellDef="let element"> {{element.percent_SAD}} </td>
        </ng-container>

        <ng-container matColumnDef="percent_NAD">
            <th mat-header-cell *matHeaderCellDef> % N-AD </th>
            <td mat-cell *matCellDef="let element"> {{element.percent_NAD}} </td>
        </ng-container>

        <ng-container matColumnDef="sadGalons">
            <th mat-header-cell *matHeaderCellDef> S-AD (gal) </th>
            <td mat-cell *matCellDef="let element"> {{element.sadGalons}} </td>
        </ng-container>

        <ng-container matColumnDef="nadGalons">
            <th mat-header-cell *matHeaderCellDef> N-AD (gal) </th>
            <td mat-cell *matCellDef="let element"> {{element.nadGalons}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                style="color: red;text-align: center;font-weight: 500;">
                No data found.
            </td>
        </tr>
    </table>
</div>